import { Box } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import { useMemo, useState } from "react";
import { RegraReservaComponentProps } from "..";
import BloqueioPeriodoAntesDepoisReservaItem from "./BloqueioPeriodoAntesDepoisReservaItem";
import ModalExcecaoDiaSemana from "./ModalExcecaoDiaSemana";
import colors from "resources/theme/colors";

export default function BloqueioPeriodoAntesDepoisReserva({
  control,
  watch,
  getNameLabel,
  onSaveRegra,
  onExcluirBloqueio,
}: RegraReservaComponentProps & {
  onExcluirBloqueio?: (diaSemana: number) => any;
}) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const bloqueios = watch("bloqueioAntesDepoisReserva");

  const regraGeral = useMemo(() => bloqueios[0], [bloqueios]);

  const excecoes = useMemo(() => bloqueios.slice(1), [bloqueios]);

  return (
    <Box>
      <BloqueioPeriodoAntesDepoisReservaItem
        control={control}
        getNameLabel={getNameLabel}
        item={regraGeral!}
        index={0}
        onSaveRegra={onSaveRegra}
        watch={watch}
      />

      <Box
        mt={
          Number.isFinite(regraGeral.periodoAntes) ||
          Number.isFinite(regraGeral.periodoDepois)
            ? 20
            : 8
        }
      >
        <OutlineButton onClick={() => setIsOpenModal(true)}>
          Criar exceção para um dia da semana
        </OutlineButton>
      </Box>

      {excecoes.map((excecao, index) => (
        <Box
          key={excecao.diaSemana}
          borderTopWidth={2}
          mt={index === 0 ? 4 : 16}
          borderTopColor={colors.black200}
          paddingTop={4}
          paddingBottom={index === excecoes.length - 1 ? 12 : 0}
        >
          <BloqueioPeriodoAntesDepoisReservaItem
            control={control}
            getNameLabel={getNameLabel}
            item={excecao}
            index={index + 1}
            onSaveRegra={onSaveRegra}
            watch={watch}
            onExcluirBloqueio={() => {
              onExcluirBloqueio?.(excecao.diaSemana!);
            }}
          />
        </Box>
      ))}

      <ModalExcecaoDiaSemana
        onSave={(diaSemana) => {
          onSaveRegra?.(
            {
              bloqueioAntesDepoisReserva: {
                diaSemana,
              },
            },
            true
          );
        }}
        filterOptions={excecoes.map((excecao) => excecao.diaSemana!)}
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
      />
    </Box>
  );
}
